/**
 * Utilitários de prioridade interna para tickets.
 *
 * Prioridade é campo interno, visível apenas para ANALISTA e ADMIN.
 * O usuário comum usa 'urgência' ao invés de prioridade.
 */

export type TicketPriority = 'p1' | 'p2' | 'p3' | 'p4';

export const PRIORITY_OPTIONS: { value: TicketPriority; label: string }[] = [
  { value: 'p1', label: 'P1 — Crítica'  },
  { value: 'p2', label: 'P2 — Alta'     },
  { value: 'p3', label: 'P3 — Média'    },
  { value: 'p4', label: 'P4 — Baixa'    },
];

const PRIORITY_COLORS: Record<TicketPriority, string> = {
  p1: 'danger',
  p2: 'warning',
  p3: 'info',
  p4: 'success',
};

const PRIORITY_LABELS: Record<TicketPriority, string> = {
  p1: 'P1',
  p2: 'P2',
  p3: 'P3',
  p4: 'P4',
};

export function getPriorityColor(priority: string | undefined | null): string {
  if (!priority) return 'secondary';
  return PRIORITY_COLORS[priority as TicketPriority] ?? 'secondary';
}

export function getPriorityLabel(priority: string | undefined | null): string {
  if (!priority) return '—';
  return PRIORITY_LABELS[priority as TicketPriority] ?? priority.toUpperCase();
}
